import { FC, useEffect, useState } from "react";

import Text from "../../../../../components/Text";
import TextArea from "../../../../../components/TextArea";
import { toast } from "react-toastify";
import {
    NOTE_CONTENT_MAX_LENGTH,
    Note as NoteType,
    PutNoteResponse,
} from "../../../../../types/api/admin/note";

import styles from "./styles.module.scss";
import { AxiosError } from "axios";
import Button from "../../../../../components/Button";

type Props = {
    title: string;
    fetchNote: () => Promise<NoteType | undefined>;
    saveNote: (content: string) => Promise<PutNoteResponse | undefined>;
};

const Note: FC<Props> = ({ title, fetchNote, saveNote }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [notesContent, setNotesContent] = useState("");

    const handleSaveNotes = async () => {
        const updatedNotes = await saveNote(notesContent);

        if (!updatedNotes) {
            toast.error("Erreur lors de la mise à jour des notes");
            return;
        }

        setIsEditing(false);
    };

    const handleCancelEdit = () => {
        setNotesContent(notesContent);
        setIsEditing(false);
    };

    useEffect(() => {
        const loadNote = async () => {
            try {
                const fetchedContent = await fetchNote();
                setNotesContent(fetchedContent?.content || "");
            } catch (error) {
                if (
                    error instanceof AxiosError &&
                    error.response?.status !== 404
                ) {
                    toast.error("Erreur lors du chargement des notes");
                }
                setNotesContent("");
            }
        };

        loadNote();
    }, [fetchNote]);

    return (
        <div>
            <div className={styles.header}>
                <Text variant="subtitle">{title}</Text>
                {isEditing ? (
                    <div className={styles.actions}>
                        <Button
                            size="newSmall"
                            variant="transparent"
                            onClick={handleCancelEdit}
                        >
                            Annuler
                        </Button>
                        <Button
                            size="newSmall"
                            variant="secondary"
                            onClick={handleSaveNotes}
                        >
                            Enregistrer
                        </Button>
                    </div>
                ) : (
                    <Button
                        size="newSmall"
                        variant="secondary"
                        onClick={() => setIsEditing(true)}
                    >
                        Modifier
                    </Button>
                )}
            </div>
            <div className={styles.content}>
                {isEditing ? (
                    <TextArea
                        className={styles.textArea}
                        value={notesContent}
                        onChange={(e) => setNotesContent(e.target.value)}
                        maxLength={NOTE_CONTENT_MAX_LENGTH}
                    />
                ) : (
                    <div className={styles.notesContent}>
                        <Text variant="body" className={styles.notesText}>
                            {notesContent || ""}
                        </Text>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Note;
